import React, { Component } from 'react';
import { ScrollView, StyleSheet, View, Platform, ViewStyle, FlatList  } from 'react-native';
import { Text, Card, Button, Layout, Icon, Input, Radio, CheckBox, Select, SelectOptionType, OverflowMenu, Modal } from '@ui-kitten/components';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { Q_GET_SURVEY_AND_RESPONSE_COUNT } from './../../data/api/query/q_survey';
import { Q_GET_CAMPAIGNS } from './../../data/api/query/q_campaigns';
import { ItemTypeHeader, SurveyTypeHeader } from './../../components/list-items/CardItem';
import { SurveySection, Survey, Question, AnswerGroup, Answer, Campaign } from './../../data/models/types';
import { M_CREATE_SURVEY_QUESTION, M_DELETE_SURVEY_QUESTION, M_CREATE_ANSWERS, M_DELETE_ANSWERS, M_UPDATE_ANSWER, M_UPDATE_SURVEY_QUESTION } from './../../data/api/mutation/m_surveys';
import { ItemRow, ThreeItemRow } from '../../components/containers/InputRow';
import { PageLoadingIndicator, LoadingIndicator, ModalLoadingIndicator } from '../../components/LoadingIndicator';
import { ApiClient } from '../../data/api/client/ApiClient';
import { upsertSurveyQuestionsParams } from '../../data/api/client/ApiClientTypes';
import { useScreenDimensions } from '../../utils/useScreenInfo';
import { BasicCard } from '../../components/_primatives';





export default function ManageSurveySectionsScreen({ navigation, route }): React.ReactElement {
    const screenDimensions = useScreenDimensions();
    const params = route?.params;
    console.log({ navigation, route, params });
    const [loading, setLoading] = React.useState(false);
    const [modalVisible, setModalVisible] = React.useState(false);
    const surveyId: string = params.survey_id;
    const campaignId: string = params.campaign_id;
    const surveyRequest = useQuery(Q_GET_SURVEY_AND_RESPONSE_COUNT, { variables: { survey_id: surveyId }, fetchPolicy: 'network-only' });
    const campaignRequest = useQuery(Q_GET_CAMPAIGNS, { variables: { campaign_id: campaignId }, fetchPolicy: 'network-only' });
    

    const _createSurveyQuestions = async (newQuestions: any[], removedQuestions: any[], updatedQuestions: any[], addedAnswerIds: string[], removedAnswerIds: string[], updatedAnswerIds: string[]) => {
        try {
            setModalVisible(true);
            console.log('_createSurveyQuestions has been called', { newQuestions, removedQuestions, updatedQuestions, addedAnswerIds, removedAnswerIds, updatedAnswerIds });
            const survey = surveyRequest.data.surveys[0];
            const surveyParticipantCount: number = survey.user_answers_aggregate.aggregate.count + survey.anon_user_answers_aggregate.aggregate.count;


            if (surveyParticipantCount > 0) {
                alert('You can\'t make edits after a user have responded');
                return;
            }
            else {
                const paramData: upsertSurveyQuestionsParams = {
                    survey_id: survey.id,
                    newQuestions,
                    removedQuestions,
                    updatedQuestions,
                    addedAnswerIds,
                    removedAnswerIds,
                    updatedAnswerIds
                };
                console.log('const upsertResult: any = ApiClient.upsertSurveyQuestions data = ', { paramData });
                const upsertResult: any = await ApiClient.upsertSurveyQuestions(paramData);
                console.log('const upsertResult: any = ApiClient.upsertSurveyQuestions', { upsertResult });
                setModalVisible(false);
                navigation.navigate('Survey', { survey: survey.id });
                return;
            }
        }
        catch(error) {
            alert('There was an issue with yor request, please review and try again. If this issue persists please contact your admin');
            setModalVisible(false);
            console.log(error);
        }
    } // end of _createSurveyQuestions()

    if (surveyRequest.loading || campaignRequest.loading) {
        return <PageLoadingIndicator />;
    }
    if (surveyRequest.error || campaignRequest.error) {
        console.log('HomeScreen error', surveyRequest.error || campaignRequest.error);
        return <Text onPress={() => { surveyRequest.refetch(); campaignRequest.refetch(); }}>Error :(</Text>
    };
    console.log('we have data, ', surveyRequest.data, campaignRequest.data)

    return (
            <ScrollView contentContainerStyle={{ flexGrow: 1 }} style={{ flex: 1 }}>
                <SurveyBuilder
                    survey={(surveyRequest && surveyRequest.data && surveyRequest.data.surveys) ? surveyRequest.data.surveys[0] : {}}
                    parentCampaign={(campaignRequest && campaignRequest.data.surveys) ? campaignRequest.data.surveys[0] : {}}
                    onCreate={_createSurveyQuestions}
                    screenDimensions={screenDimensions}
                    navigation={navigation}
                />
                <ModalLoadingIndicator
                    modalVisible={modalVisible}
                />
            </ScrollView>
    );
}


interface SurveyBuilderProps {
    survey: Survey;
    parentCampaign: Campaign;
    onCreate: (newQuestions: any[], removedQuestions: any[], updatedQuestions: any[], addedAnswerIds: string[], removedAnswerIds: string[], updatedAnswerIds: string[]) => Promise<any>;
    screenDimensions: any;
    navigation: any;
}
interface SurveyBuilderState { 
    sections: any[];
    removedSections: any[];
    removedQuestions: Question[],
    updatedQuestionIds: string[],
    removedAnswerIds: string[],
    updatedAnswerIds: string[],
    addedAnswerIds: string[]
}

class SurveyBuilder extends Component<SurveyBuilderProps, SurveyBuilderState> {
    constructor(props: Readonly<SurveyBuilderProps>) {
        super(props);
        console.log('constructor(props: Readonly<SurveyBuilderProps>) props = ', props);
        this.state = {
            sections: props.survey.survey_sections,
            removedSections: [],
            removedQuestions: [],
            updatedQuestionIds: [],

            addedAnswerIds: [],
            updatedAnswerIds: [],
            removedAnswerIds: [],
        };
    }
    
    
    _updateSection(section_id: string, key: string, value: string): void {
        console.log(`_updateSection(${section_id}, ${key}, ${value}): `, this.state.sections);
        const newSections = this.state.sections.map((section: SurveySection) => {
            if (section.id === section_id) {
                section[key] = value;
                return { ...section };
            }
            else {
                return section;
            }
        });
        console.log('newSections', newSections);
        this.setState({ sections: newSections });
    }


    _addToRemovedQuestionList(question: Question) {
        console.log(`_addToRemovedQuestionList(question: Question), this.state.removedQuestions`, question);
        if (question.id && question.id.substr(0, 3) === 'new') {
            // we only need to remove questions that currently exist in the database
            // ignore questions created client side
            console.log(`_addToRemovedQuestionList was passed a question created client side, this question isnt tracked for removal`);
        }
        else {
            const updatedQuestions: Question[] = [...this.state.removedQuestions, {...question}];
            this.setState({ removedQuestions: updatedQuestions });
            console.log(`_addToRemovedQuestionList was passed a question for removal that needs to be tracked`, this.state.removedQuestions);
        }
    }


    _addToRemovedAnswerList(questionId: string, answerId: string) {
        console.log(`_questionUpdated(questionId: string) ` + answerId);
        if (questionId && questionId.substr(0, 3) === 'new') {
            // we only need to remove questions that currently exist in the database
            // ignore questions created client side
            console.log(`_addToRemovedAnswerList was passed an answer for a question created client side, this answer isnt tracked for removal`);
        }
        else {
            const removedAnswerIds: string[] =  this.state.removedAnswerIds;
            const addedAnswerIds: string[] =  this.state.addedAnswerIds;

            if (removedAnswerIds.findIndex(id => id === answerId) >= 0) {
                // id is already in the array
                console.log(`Answer ${answerId} has been updated but is already in the removedAnswerIds array`);
                return;
            }
            else if (addedAnswerIds.findIndex(id => id === answerId) >= 0) {
                // id is already in the array
                this.setState({ addedAnswerIds: addedAnswerIds.filter(id => id !== answerId) });
                console.log(`Answer ${answerId} was created client side and was removed from the addedAnswerIds array`);
                return;
            }
            else {
                // add answer Id to array
                removedAnswerIds.push(answerId);
                this.setState({ removedAnswerIds: [...removedAnswerIds] });
                console.log(`Answer ${answerId} has been added to the removedAnswerIds array`, this.state.removedAnswerIds);
            }
        }
    }


    _addToUpdatedAnswerList(questionId: string, answerId: string) {
        console.log(`_addToUpdatedAnswerList(questionId: ${questionId}, answerId: ${ answerId})`);
        if (questionId && questionId.substr(0, 3) === 'new') {
            // we only need to remove questions that currently exist in the database
            // ignore questions created client side
            console.log(`_addToUpdatedAnswerList was passed an answer for a question created client side, this answer isnt tracked for udpates`);
        }
        else if (answerId && answerId.substr(0, 3) === 'new') {
            // we only need to remove questions that currently exist in the database
            // ignore questions created client side
            console.log(`_addToUpdatedAnswerList was passed an answer that was created client side, this answer isnt tracked for updates`);
        }
        else {
            const updatedAnswerIds: string[] =  this.state.updatedAnswerIds;
            if (updatedAnswerIds.findIndex(id => id === answerId) >= 0) {
                // id is already in the array
                console.log(`Answer ${answerId} has been updated but is already in the updatedAnswerIds array`);
                return;
            }
            else {
                // add answer Id to array
                updatedAnswerIds.push(answerId);
                this.setState({ updatedAnswerIds: [...updatedAnswerIds] });
                console.log(`Answer ${answerId} has been added to the updatedAnswerIds array`, this.state.updatedAnswerIds);
            }
        }
    }


    _addToAddedAnswerList(questionId: string, answerId: string) {
        console.log(`_addToAddedAnswerList(questionId: ${questionId}, answerId: ${ answerId})`);
        if (questionId && questionId.substr(0, 3) === 'new') {
            // we only need to remove questions that currently exist in the database
            // ignore questions created client side
            console.log(`_addToAddedAnswerList was passed an answer for a question created client side, this answer isnt tracked for removal`);
        }
        else {
            const addedAnswerIds: string[] =  this.state.addedAnswerIds;
            if (addedAnswerIds.findIndex(id => id === answerId) >= 0) {
                // id is already in the array
                console.log(`Answer ${answerId} has been updated but is already in the addedAnswerIds array`);
                return;
            }
            else {
                // add answer Id to array
                addedAnswerIds.push(answerId);
                this.setState({ addedAnswerIds: [...addedAnswerIds] });
                console.log(`Answer ${answerId} has been added to the addedAnswerIds array`, this.state.addedAnswerIds);
            }
        }
    }


    _questionUpdated(questionId: string) {
        console.log(`_questionUpdated(questionId: string) ` + questionId);
        const questionsIds: string[] =  this.state.updatedQuestionIds;
        if (questionsIds.findIndex(id => id === questionId) >= 0) {
            // id is already in the array
            console.log(`Question ${questionId} has been updated but is already in the updatedQuestionIds array`);
            return;
        }
        else {
            // add question Id to array
            questionsIds.push(questionId);
            this.setState({ updatedQuestionIds: [...questionsIds] });
            console.log(`Question ${questionId} has been updated add added to the updatedQuestionIds array`, this.state.updatedQuestionIds);
        }
    }


    _updateSectionQuestion(section_id: string, question_id: string, key: string, value: string | number | boolean): void {
        console.log(`_updateSection(${section_id}, ${key}, ${value}): `, this.state.sections);
        const newSections: SurveySection[] = this.state.sections.map((section: SurveySection) => {
            if (section.id === section_id) {
                if (section.questions) {
                    const newQuestions: Question[] = section.questions.map((question: Question) => {
                        if (question.id === question_id) {
                            question[key] = value;
                            this._questionUpdated(question.id);
                            return { ...question };
                        }
                        else {
                            return question;
                        }
                    });
                    section.questions = [...newQuestions];
                    return { ...section };
                }
                else {
                    throw new Error(`Section ${section_id} was found but couldn't find question with id ${question_id}!`);
                }
            }
            else {
                return section;
            }
        });
        console.log('newSections', newSections);
        this.setState({ sections: newSections });
    }


    _updateSectionQuestionAnswer(section_id: string, question_id: string, answer_id: string, key: string, value: string | number | boolean): void {
        console.log(`_updateSection(${section_id}, ${question_id}, ${key}, ${value}): `, this.state.sections);
        const newSections: SurveySection[] = this.state.sections.map((section: SurveySection) => {
            if (section.id === section_id) {
                if (section.questions) {
                    const newQuestions: Question[] = section.questions.map((question: Question) => {
                        if (question.id === question_id) {

                            if (question.answer_groups && question.answer_groups[0] && question.answer_groups[0].possible_answers) {
                                const newAnswers: Answer[] = question.answer_groups[0].possible_answers.map((answer: Answer) => {
                                    if (answer.id === answer_id) {
                                        answer[key] = value;
                                        this._questionUpdated(question.id);
                                        this._addToUpdatedAnswerList(question.id, answer.id);
                                        // return updated answer
                                        return { ...answer };
                                    }
                                    else {
                                        return answer;
                                    }
                                });

                                // update question answers
                                question.answer_groups[0].possible_answers = [...newAnswers];
                            }
                            else {
                                throw new Error(`Section ${section_id} was found but couldn't find question with id ${question_id}!`);
                            }
                            // return update question
                            return { ...question };
                        }
                        else {
                            return question;
                        }
                    });
                    section.questions = [...newQuestions];
                    return { ...section };
                }
                else {
                    throw new Error(`Section ${section_id} was found but couldn't find question with id ${question_id}!`);
                }
            }
            else {
                return section;
            }
        });
        console.log('newSections', newSections);
        this.setState({ sections: newSections });
    }


    _addOrRemoveSection = (section_id: string,  operationType: 'add' | 'remove'): void => {
        if (operationType === 'add') {
            const newIndex: number = (this.state.sections && this.state.sections.length) ? this.state.sections.length : 0;
            this.setState({
                sections: this.state.sections.concat([
                    getNewSection(newIndex)
                ])
            });
        }
        else {
            this.setState({
                sections: this.state.sections.filter((section: SurveySection) =>
                    section.id !== section_id
                )
            });
        }
    }


    _addOrRemoveQuestion = async (section_id: string, question_id: string, operationType: 'add' | 'remove') => {
        const newSections: SurveySection[] = this.state.sections.map((section: SurveySection) => {
            if (section.id === section_id) {
                if (section.questions) {
                    let newQuestions: Question[] = [];
                    // we found the question that needs to be updated
                    if (operationType === 'add') {
                        const newQuestion: Question = getNewQuestion('select', section.questions.length);
                        newQuestions = section.questions.concat(newQuestion);
                    }
                    else {                        
                        newQuestions = section.questions.filter((question: Question) => {
                            if (question.id === question_id) {
                                this._addToRemovedQuestionList(question);
                                return false;
                            }

                            return true;
                        });
                    }
                    section.questions = [...newQuestions];
                    return { ...section };
                }
                else {
                    throw new Error(`Section ${section_id} was found but couldn't find question with id ${question_id}!`);
                }
            }
            else {
                return section;
            }
        });
        console.log('newSections', newSections);
        this.setState({ sections: newSections });
    }


    _addOrRemoveAnswer = (section_id: string, question_id: string, answer_id: string, operationType: 'add' | 'remove') => {
        console.log(`_addOrRemoveAnswer = (section_id: string, question_id: string, answer_id: string, operationType: 'add' | 'remove') => { fired`, section_id,
        question_id,
        answer_id,
        operationType)
        const newSections: SurveySection[] = this.state.sections.map((section: SurveySection) => {
            if (section.id === section_id) {
                console.log('found the section_id');
                if (section.questions) {
                    console.log('found the questions');
                    const newQuestions: Question[] = section.questions.map((question: Question) => {
                        if (question.id === question_id) {
                            console.log('found the question_id');

                            if (question.answer_groups && question.answer_groups[0] && question.answer_groups[0].possible_answers) {
                                const answers: Answer[] = question.answer_groups[0].possible_answers;
                                console.log('the question we found has possible_answers', answers);
                                let newAnswers: Answer[] = [];
                                if (operationType === 'add') {
                                    const newAnswer: Answer = getNewAnswer(answers.length);
                                    newAnswers = answers.concat(newAnswer);
                                    this._addToAddedAnswerList(question.id, newAnswer.id);
                                    this._questionUpdated(question.id);
                                }
                                else {
                                    // remove the answer
                                    newAnswers = answers.filter((answer: Answer) => answer.id !== answer_id );
                                    this._addToRemovedAnswerList(question.id, answer_id);
                                    this._questionUpdated(question.id);
                                }
                                console.log('We have updated the answers and will now add them set them to the possibleAnswers array', newAnswers);
                                // update question answers
                                question.answer_groups[0].possible_answers = [...newAnswers];
                            }
                            else {
                                throw new Error(`Question ${question.id} was found but couldn't find answer with id ${answer_id}!`);
                            }
                            // return update question
                            return { ...question };
                        }
                        else {
                            return question;
                        }
                    });
                    section.questions = [...newQuestions];
                    return { ...section };
                }
                else {
                    throw new Error(`Section ${section.id} was found but couldn't find question with id ${question_id}!`);
                }
            }
            else {
                return section;
            }
        });
        console.log('newSections', newSections);
        this.setState({ sections: newSections });
    }

    
    _onSubmit = async () => {
        const sections: SurveySection[] = this.state.sections;
        
        
        let addedQuestions: any = [];
        let existingQuestions: any = [];

        sections[0].questions.forEach((question: Question) => {
            console.log('sections[0].questions.forEach((question: Question) => {', question);
            if (question.id && question.id.substr(0, 3) === 'new') {
                console.log('if (question.id && question.id.substr(0, 3) === new) TRUE');
                addedQuestions.push(question); // this has been generated by the client
            }
            else {
                console.log('exisiting question');
                existingQuestions.push(question); // this has been grabbed from teh db
            }
        });


        try {
            // transform form data to api call object shape
            const modAddedQuestions = addedQuestions.map((question: Question, questionIndex: number) => {
                const answers: { answer_index: number; answer_text: string }[] = question.answer_groups[0].possible_answers.map((answer: Answer, index: number) => {
                    return {
                        answer_index: index,
                        answer_text: answer.answer_text
                    }
                });
    
                return {
                    survey_section_id: sections[0].id,
                    answer_is_required: question.answer_is_required,
                    question_index: questionIndex,
                    question_is_required: question.question_is_required,
                    question_subtitle: question.question_subtitle,
                    question_title: question.question_title,
                    question_type: question.question_type,
                    answer_groups: {
                        data: [
                            {
                                possible_answers: {
                                    data: answers
                                }
                            }   
                        ]
                    }
                }
            });

            // replace original questions with tranlated
            addedQuestions = [...modAddedQuestions];
            // existingQuestions = [...modExistingQuestions];
        }
        catch (error) {
            console.log('ERROR when trying to transform form data to api call object shape', error);
            alert('There was an error with the request')
        }
        // console.log('addedQuestions', addedQuestions, JSON.stringify(addedQuestions, null, 4));
        // console.log('existingQuestions', existingQuestions, JSON.stringify(existingQuestions, null, 4));

        // get the questions to be updated and removed
        const updatedQuestionIds: string[] = this.state.updatedQuestionIds;
        const questionsToBeUpdated: any = existingQuestions.filter((question: Question) => updatedQuestionIds.findIndex((id: string) => id === question.id) >= 0);
        const removeQuestions: any = this.state.removedQuestions;
        const addedAnswerIds: string[] = this.state.addedAnswerIds;
        const removedAnswerIds: string[] = this.state.removedAnswerIds;
        const updatedAnswerIds: string[] = this.state.updatedAnswerIds;

        this.props.onCreate(addedQuestions, removeQuestions, questionsToBeUpdated, addedAnswerIds, removedAnswerIds, updatedAnswerIds);
    };


    renderHeader = () => {
        const { survey, screenDimensions, navigation} = this.props;
        return (
            <View style={{ marginVertical: 20, marginBottom: 30, paddingHorizontal: screenDimensions.isMediumScreenOrLarger ? 0 : 23 }}>
                <SurveyTypeHeader />
                <Text category='h1'>{survey.title}</Text>
                <Text category='s1'>{survey.description}</Text>
                {survey.instructions ? <Text category='p1' appearance='hint'>{survey.instructions}</Text> : undefined}
        
                <Button
                    onPress={() => navigation.navigate('EditSurvey', { survey_id: survey.id })}
                    icon={(style) => <Icon {...style} name='edit-outline' />}
                    status='basic'
                    appearance='ghost'
                    style={{position: 'absolute', right: 0, top: 0}}
                />
            </View>
        )
    };
    renderFooter = () => {
        const { survey, screenDimensions, navigation} = this.props;
        const { sections, removedSections, removedQuestions, updatedQuestionIds, addedAnswerIds, updatedAnswerIds, removedAnswerIds, } = this.state;
        const allowSubmit: boolean = 
            (sections && sections.length && sections[0].questions && sections[0].questions.length > 0) ||
            (removedSections && removedSections.length > 0) || 
            (removedQuestions && removedQuestions.length > 0) || 
            (updatedQuestionIds && updatedQuestionIds.length > 0) || 
            (addedAnswerIds && addedAnswerIds.length > 0) || 
            (updatedAnswerIds && updatedAnswerIds.length > 0) || 
            (removedAnswerIds && removedAnswerIds.length > 0);
        return (
            <View style={{ marginVertical: 75, marginBottom: 150, paddingHorizontal: screenDimensions.isMediumScreenOrLarger ? 0 : 23 }}>
                <Button onPress={this._onSubmit} disabled={!allowSubmit} style={{ width: screenDimensions.isMediumScreenOrLarger ? 250 : undefined }}>Save</Button>
            </View>
        )
    };
    keyExtractor = (item) => item.id;
    renderItem = ({ item }) => (
        <SurveyBuilderSection
            section={item}
            isMediumScreenOrLarger={this.props.screenDimensions.isMediumScreenOrLarger}
            
            onSectionChange={(section_id: string, key: string, value: string) => this._updateSection(section_id, key, value)}
            updateSectionQuestion={(section_id: string, question_id: string, key: string, value: string) => this._updateSectionQuestion(section_id, question_id, key, value)}
            updateSectionQuestionAnswer={(section_id: string, question_id: string, answer_id: string, key: string, value: string) => this._updateSectionQuestionAnswer(section_id, question_id, answer_id, key, value)}
            
            addOrRemoveSection={(section_id: string, operationType: 'add' | 'remove') => this._addOrRemoveSection(section_id, operationType)}
            addOrRemoveQuestion={(section_id: string, question_id: string, operationType: 'add' | 'remove') => this._addOrRemoveQuestion(section_id, question_id, operationType)}
            addOrRemoveAnswer={(section_id: string, question_id: string, answer_id: string, operationType: 'add' | 'remove') => this._addOrRemoveAnswer(section_id, question_id, answer_id, operationType)}
            key={item.id}
        />
    )

    render() {
        const { pageSpacerHorizontal, isMediumScreenOrLarger, bodyWidth } = this.props.screenDimensions;
        return (
            <Layout level='1' style={{ flex: 1 }}>
                <FlatList
                    data={this.state.sections}
                    renderItem={this.renderItem}
                    keyExtractor={this.keyExtractor}
                    ListHeaderComponent={this.renderHeader}
                    ListFooterComponent={this.renderFooter}
                    style={{ flex: 1, paddingHorizontal: pageSpacerHorizontal }}
                    contentContainerStyle={isMediumScreenOrLarger ? { width: bodyWidth, alignSelf: 'center', paddingTop: 0 } : undefined}
                />
            </Layout>
        );
    }
}


interface SurveyBuilderSectionProps {
    section: SurveySection;
    onSectionChange: (section_id: string, key: string, value: string | number | boolean) => void;
    updateSectionQuestion: (section_id: string, question_id: string, key: string, value: string | number | boolean) => void;
    updateSectionQuestionAnswer: (section_id: string, question_id: string, answer_id: string, key: string, value: string | number | boolean) => void;
    addOrRemoveSection: (section_id: string, operationType: 'add' | 'remove') => void;
    addOrRemoveQuestion: (section_id: string, question_id: string, operationType: 'add' | 'remove') => void;
    addOrRemoveAnswer: (section_id: string, question_id: string, answer_id: string, operationType: 'add' | 'remove') => void;
    isMediumScreenOrLarger: boolean;
}
const SurveyBuilderSection = (props: SurveyBuilderSectionProps) => {
    const section: SurveySection = props.section;
    const isMediumScreenOrLarger = props.isMediumScreenOrLarger;
    console.log('SurveyBuilderSection', section);
    const _onSectionChange = (key: string, value: string | number | boolean) => props.onSectionChange(section.id, key, value);
    const _onQuestionChange = (question_id: string, key: string, value: string | number | boolean) => props.updateSectionQuestion(section.id, question_id, key, value);
    const _onAnswerChange = (question_id: string, answer_id: string, key: string, value: string | number | boolean) => props.updateSectionQuestionAnswer(section.id, question_id, answer_id, key, value);

    const _addOrRemoveSection = (operationType: 'add' | 'remove') => props.addOrRemoveSection(section.id, operationType);
    const _addOrRemoveQuestion = (question_id: string, operationType: 'add' | 'remove') => props.addOrRemoveQuestion(section.id, question_id, operationType);
    const _addOrRemoveAnswer = (question_id: string, answer_id: string, operationType: 'add' | 'remove') => props.addOrRemoveAnswer(section.id, question_id, answer_id, operationType);


    return (
        <View>
            {/* 
                Section Header
            */}
            {section.is_container_only ?
                <BasicCard>
                    <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                        {/* <Text category='s1'>{`SECTION ${section.section_index} - ${section.section_is_required ? 'required' : 'optional'}`}</Text> */}
                        <Text category='s1'>{'SECTION'}</Text>
                        <MenuButton
                            onPress={() => _addOrRemoveSection('remove')}
                            // title={`Remove Section`}
                        />
                        
                        {/* <Button
                            onPress={() => _addOrRemoveQuestion(question.id, 'add')}
                            status='basic'
                            style={{ width: 25, height: 25 }}
                            icon={RemoveIcon}
                        /> */}
                        {/* <Toggle
                            text={`${section.section_is_required ? 'Required' : 'Optional'} Section`}
                            checked={section.section_is_required}
                            onChange={(isChecked: boolean) => _onSectionChange('section_is_required', isChecked)}
                        /> */}
                    </View>
                    <Input
                        value={section.section_title}
                        onChangeText={(text) => _onSectionChange('section_title', text)}
                    />
                    <Input
                        value={section.section_subtitle}
                        onChangeText={(text) => _onSectionChange('section_subtitle', text)}
                    />
                </BasicCard>
            : undefined}
            {/* 
                Questions
            */}
            {(section.questions && section.questions.length > 0) ? section.questions.map((question: Question, qIndex: number) => 
                <BasicCard key={question.id}
                    style={isMediumScreenOrLarger ? { marginBottom: 15 } : { borderWidth: 0 }}
                >
                    <ItemRow style={{ justifyContent: 'space-between' }}>
                        <Text category='s1'>{`Question`}</Text>
                        <MenuButton onPress={() => _addOrRemoveQuestion(question.id, 'remove')} />
                    </ItemRow>
                    <ThreeItemRow
                        left={
                            <Text category='s1' style={{ textAlign: 'right' }}>{`Q`}</Text>
                        }
                        center={
                            <Input
                                value={question.question_title}
                                onChangeText={(text) => _onQuestionChange(question.id, 'question_title', text)}
                                style={{ flex: 1  }}
                            />
                        }
                        right={undefined}
                    />
                    <ThreeItemRow
                        left={<Text category='s1' style={{ textAlign: 'right' }}>{`Type`}</Text>}
                        center={
                            <BasicQuestionTypeSelect
                                onSelect={(option: SelectOptionType) => _onQuestionChange(question.id, 'question_type', option.text)}
                                selected={question.question_type}
                            />
                        }
                        right={
                            <AddButton title={isMediumScreenOrLarger ? 'Add Answer' : ''} onPress={() => _addOrRemoveAnswer(question.id, undefined, 'add')} />
                        }
                        style={{ marginBottom: 10 }}
                    />


                    {/* 
                        Questions
                    */}
                    {question.answer_groups.map((ag: AnswerGroup) => 
                        <View key={ag.id}>
                            {/* <Text category='s1'>ag name & id: {ag.answer_group_name}- {ag.id}</Text> */}
                            {
                                question.question_type === 'text' ? (
                                    <>
                                        {ag.possible_answers.map((answer: Answer, answerIndex: number) =>
                                            <ThreeItemRow
                                                left={<Text category='s1' style={{ textAlign: 'right' }}>{`A`}</Text>}
                                                center={
                                                    <Input
                                                        value={answer.answer_text}
                                                        onChangeText={(text) => _onAnswerChange(question.id, answer.id, 'answer_text', text)}
                                                    />
                                                }
                                                right={
                                                    <RemoveButton onPress={() => _addOrRemoveAnswer(question.id, answer.id, 'remove')} />
                                                }
                                                key={answer.id}
                                            />
                                        )}
                                    </>
                                ) : question.question_type === 'select' ? (
                                    <>
                                        {ag.possible_answers.map((answer: Answer) =>
                                            <ThreeItemRow
                                                left={
                                                    <Radio />
                                                }
                                                center={
                                                    <Input
                                                        value={answer.answer_text}
                                                        onChangeText={(text) => _onAnswerChange(question.id, answer.id, 'answer_text', text)}
                                                    />
                                                }
                                                right={
                                                    <RemoveButton onPress={() => _addOrRemoveAnswer(question.id, answer.id, 'remove')} />
                                                }
                                                key={answer.id}
                                            />
                                        )}
                                    </>
                                ) : question.question_type === 'multiselect' ? (
                                    <>
                                        {ag.possible_answers.map((answer: Answer) =>
                                            <ThreeItemRow
                                                left={
                                                    <CheckBox />
                                                }
                                                center={
                                                    <Input
                                                        value={answer.answer_text}
                                                        onChangeText={(text) => _onAnswerChange(question.id, answer.id, 'answer_text', text)}
                                                    />
                                                }
                                                right={
                                                    <RemoveButton onPress={() => _addOrRemoveAnswer(question.id, answer.id, 'remove')} />
                                                }
                                                key={answer.id}
                                            />

                                        )}
                                    </>
                                ): undefined
                            }                   
                        </View>
                    )}
                </BasicCard>
                )
                : undefined
            }
            {/* <BasicCard style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0, marginTop: -2 }}> */}
            <BasicCard 
                // style={[{ paddingLeft: pageSpacerHorizontal > 0 ? 5 : 0, borderRadius: 0}]}
                style={isMediumScreenOrLarger ? { marginBottom: 15 } : { borderWidth: 0 }}
            >
                <View style={{ flexDirection: 'row', justifyContent: (section.questions && section.questions.length > 0) ? 'flex-end' : 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
                    {!(section.questions && section.questions.length > 0) ? 
                        <View>
                            <Text category='s1'>{'Your survey needs some questions!'}</Text>
                            <Text category='s1' appearance='hint'>{'Add a question to get started'}</Text>
                        </View>
                        : undefined
                    }
                    <AddButton onPress={() => _addOrRemoveQuestion(section.id, 'add')} title={'Add Question'} />
                </View>
            </BasicCard>
        </View>
    );
};



const RemoveIcon = (style: any) => (
    <Icon {...style} name='trash-2-outline' />
);


const AddIcon = (style: any) => (
    <Icon {...style} name='plus' />
);



const buttonStyle: ViewStyle = { height: Platform.OS === 'web' ? 40 : 43 };
interface ButtonProps  { title?: string; onPress: () => void; }

const AddButton = ({ title, onPress }: ButtonProps) => (
    <Button
        onPress={onPress}
        icon={AddIcon}
        status='basic'
        size='small'
        style={buttonStyle}
    >
        {title}
    </Button>
);
const RemoveButton = ({ title, onPress }: ButtonProps) => (
    <Button
        onPress={onPress}
        icon={RemoveIcon}
        status='basic'
        size='small'
        style={buttonStyle}
    >
        {title}
    </Button>
);
const MenuButton = ({ title, onPress }: ButtonProps) => (
    <Button
        onPress={onPress}
        icon={RemoveIcon}
        status='basic'
        appearance='ghost'
        size='small'
        style={buttonStyle}
    >
        {title}
    </Button>
);


const basicQuestionTypeSelectData: SelectOptionType[] = [
    // { text: 'textarea', value: 'Free form entry' },
    { text: 'select', value: 'Select one option' },
    { text: 'multiselect', value: 'Select one or more options' },
    { text: 'text', value: 'Free form entry' },
    // { text: 'number', value: 'Number value' },
    // { text: 'decimal', value: 'Decimal value' },
];



interface BasicQuestionTypeSelectProps {
    onSelect: (option: SelectOptionType) => void;
    selected?: string;
    style?: ViewStyle;
}

export class BasicQuestionTypeSelect extends Component<BasicQuestionTypeSelectProps, { selectedOptionIndex: number }> {
    constructor(props: Readonly<BasicQuestionTypeSelectProps>) {
        super(props)
        const initialIndex: any = basicQuestionTypeSelectData.findIndex(item => item.text === props.selected);
        this.state = {
            selectedOptionIndex: initialIndex >= 0 ? initialIndex : 0
        }
    };

    _onSelect = (option: SelectOptionType) => {
        const newIndex: any = basicQuestionTypeSelectData.findIndex(item => item.text === option.text);
        console.log(option, newIndex);
        this.setState({ selectedOptionIndex: newIndex });
        this.props.onSelect(option);
    }

    render() {
        const { selectedOptionIndex } = this.state;
        return (
            <Select
                data={basicQuestionTypeSelectData}
                selectedOption={basicQuestionTypeSelectData[selectedOptionIndex]}
                onSelect={this._onSelect}
                style={[{ minWidth: 125 }, this.props.style]}
            />
        );
    }
};





const data = [
    { title: 'Enable Sections' },
    {
        title: 'Menu Item 2',
        disabled: true,
    },
    { title: 'Menu Item 3' },
    { title: 'Menu Item 4' },
];

export const SectionMenu = () => {

    const [menuVisible, setMenuVisible] = React.useState(false);
    const [selectedIndex, setSelectedIndex] = React.useState(null);

    const onItemSelect = (index) => {
        setSelectedIndex(index);
        setMenuVisible(false);
    };

    const toggleMenu = () => {
        setMenuVisible(!menuVisible);
    };

    return (
        <Layout style={styles.container}>
            <OverflowMenu
                data={data}
                visible={menuVisible}
                selectedIndex={selectedIndex}
                onSelect={onItemSelect}
                onBackdropPress={toggleMenu}
            >
                <Button onPress={toggleMenu} status='basic' size='medium'>
                    {'Options'}
                </Button>
            </OverflowMenu>
        </Layout>
    );
};

const styles = StyleSheet.create({
    container: {
        // minHeight: 256,
    },
});






function getNewSection(surveyIndex?: number): SurveySection {
    const newSurvey: SurveySection = {
        id: 'new-section-id-' + Date.now() + Math.random(),
        section_title: 'Section Title',
        section_name: 'Section Name',
        section_subtitle: 'Section Subtitle',
        section_index: surveyIndex ? surveyIndex : 0,
        section_is_required: true,
        is_container_only: false,
        questions: [
            getNewQuestion(),
        ]
    }
    return newSurvey;
}


function getNewQuestion(questionType?: string, questionIndex?: number): Question {
    const question: Question = {
        id: 'new-question-id-' + Date.now() + Math.random(),
        question_type: questionType ? questionType : 'select',
        question_title: 'Question title here...',
        question_subtitle: 'Question subtitle here...',
        question_index: questionIndex ? questionIndex : 0,
        answer_is_required: true,
        question_is_required: true,
        answer_groups: [{
            id: 'new-answer_group-id-' + Date.now(),
            answer_group_name: 'new-answer_group_name-' + Date.now(),
            possible_answers: [
                getNewAnswer(),
                getNewAnswer()
            ]
        }]
    };
    return question;
}


function getNewAnswer(answerIndex?: number): Answer {
    const answer: Answer = {
            id: 'new-possible_answer-id-' + Date.now() + Math.random(),
            answer_text: 'Answer Text',
            answer_index: answerIndex ? answerIndex : 0,
            user_answers: []
    };
    return answer;
}